import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { globalBus } from '../../streams/wsBus';

interface NavItem {
  id: string;
  label: string;
  route: string;
  badge?: string;
}

export function SideNav() {
  const [items, setItems] = useState<NavItem[]>([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const unsub = globalBus.subscribe((message) => {
      if (message.t === '__status') {
        setConnected(message.status === 'connected');
      }
      if (message.t === 'scene' && message.id === 'hivecore.nav') {
        const widgets = message.body?.widgets ?? [];
        const navWidgets = widgets.filter((w: any) => w.kind === 'nav');
        setItems(navWidgets.map((w: any) => ({
          id: w.key ?? w.route ?? w.label,
          label: w.label,
          route: w.route,
          badge: w.badge
        })));
      }
    });
    globalBus.sendIntent('scene.request', { id: 'hivecore.nav' });
    return unsub;
  }, []);

  const activeRoute = useMemo(() => location.pathname, [location.pathname]);

  return (
    <nav className="workspace-sidenav" aria-label="HiveCore navigation">
      <header className="workspace-sidenav-header">
        <div className="workspace-sidenav-status">
          <span className={`workspace-sidenav-indicator ${connected ? 'is-online' : 'is-offline'}`} />
          <span className="workspace-sidenav-title">HiveCore Workstation</span>
        </div>
        <span className="workspace-sidenav-subtitle">Agentic control center</span>
      </header>
      <div className="workspace-sidenav-items" role="list">
        {items.map(item => {
          const isActive = activeRoute === item.route;
          return (
            <button
              key={item.id}
              type="button"
              role="listitem"
              className={`workspace-sidenav-item ${isActive ? 'is-active' : ''}`}
              onClick={() => navigate(item.route)}
            >
              <span className="workspace-sidenav-item-label">{item.label}</span>
              {item.badge && <span className="workspace-sidenav-item-badge">{item.badge}</span>}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
